"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const LogoutIconM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== "auto") {
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
        size.width = width;
    }
    if (height && height !== "auto") {
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
        size.height = height;
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ id: "Capa_1", "data-name": "Capa 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 198 200" }, size, { style: Object.assign({}, insetPosition), fill: fill }),
            react_1.default.createElement("path", { id: "Trazado_1879", d: "M120.9,199H38c-20.6,0-37.2-16.7-37.2-37.3c0-4.2,3.4-7.6,7.6-7.6s7.6,3.4,7.6,7.6l0,0\r\n\t\t\t\tc0,12.1,9.8,22,22,22.1h82.9c12.2,0,22-9.9,22-22.1V38.3c0-12.2-9.9-22-22.1-22H38c-12.1,0-22,9.9-22,22c0,4.2-3.4,7.6-7.6,7.6\r\n\t\t\t\ts-7.6-3.4-7.6-7.6C0.8,17.7,17.5,1,38,1h82.9c20.6,0,37.2,16.7,37.3,37.3v123.4C158.2,182.3,141.5,199,120.9,199L120.9,199z" }),
            react_1.default.createElement("path", { id: "Trazado_1880", d: "M52.1,92.6l17.5-17.5c2-1.9,2.8-4.8,2.1-7.4c-1.1-4.1-5.2-6.5-9.3-5.5c-1.3,0.3-2.6,1.1-3.5,2.1\r\n\t\t\t\tL28.5,94.7c-1.4,1.4-2.2,3.4-2.2,5.4c0,2,0.8,4,2.3,5.4l30.6,30.3c1.4,1.4,3.3,2.2,5.3,2.2c3.1,0,5.9-1.8,7.1-4.7\r\n\t\t\t\tc1.2-2.9,0.5-6.1-1.7-8.3l-17.3-17.1h72.7c4.2,0,7.6-3.4,7.6-7.6c0-4.2-3.4-7.6-7.6-7.6C125.2,92.6,52.1,92.6,52.1,92.6z" }))));
};
exports.default = LogoutIconM;
//# sourceMappingURL=index.js.map